import { useEffect } from 'react'
import { useSearchParams, useNavigate } from 'react-router-dom'
import { CheckCircle2, XCircle, Loader2 } from 'lucide-react'
import { Button } from '@/components/ui/button'

export default function MCPOAuthCallback() {
  const [params] = useSearchParams()
  const navigate = useNavigate()

  const success = params.get('success') === 'true'
  const error = params.get('error')
  const server = params.get('server')

  useEffect(() => {
    if (success) {
      const timer = setTimeout(() => {
        window.close()
      }, 1500)
      return () => clearTimeout(timer)
    }
  }, [success])

  const handleClose = () => {
    window.close()
    setTimeout(() => navigate('/profile'), 100)
  }

  return (
    <div className='min-h-screen flex items-center justify-center bg-background p-4'>
      <div className='max-w-md w-full rounded-xl border bg-card p-8 shadow-sm text-center space-y-4'>
        {success ? (
          <>
            <CheckCircle2 className='h-12 w-12 text-green-500 mx-auto' />
            <h1 className='text-xl font-semibold'>Connected Successfully</h1>
            <p className='text-sm text-muted-foreground'>
              {server
                ? `Your ${server} account has been connected.`
                : 'Your account has been connected.'}
              {' '}LLMs can now use this service during conversations.
            </p>
            <p className='text-xs text-muted-foreground'>
              <Loader2 className='h-3 w-3 animate-spin inline mr-1' />
              Closing tab…
            </p>
          </>
        ) : (
          <>
            <XCircle className='h-12 w-12 text-destructive mx-auto' />
            <h1 className='text-xl font-semibold'>Connection Failed</h1>
            <p className='text-sm text-muted-foreground'>
              {error === 'access_denied'
                ? 'You declined the authorization request.'
                : error === 'invalid_state'
                ? 'The request could not be verified. Please try again.'
                : error === 'exchange_failed'
                ? 'Token exchange failed. Please try connecting again.'
                : 'Something went wrong. Please try again.'}
            </p>
            <Button onClick={handleClose} variant='outline' className='w-full'>
              Close
            </Button>
          </>
        )}
      </div>
    </div>
  )
}
